import { render, staticRenderFns } from "./contract-summary.vue?vue&type=template&id=625afb1c"
import script from "./contract-summary.vue?vue&type=script&lang=js"
export * from "./contract-summary.vue?vue&type=script&lang=js"
import style0 from "./contract-summary.vue?vue&type=style&index=0&id=625afb1c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports